<template>
  <v-container class="d-flex align-center justify-center fluid fill-height">
    <v-card outlined width="350" tile>
      <v-card-title>
        Login
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form v-model="isValid" ref="form">
          <v-text-field
            v-model="email"
            :rules="emailRules"
            type="email"
            label="Email"
          >
          </v-text-field>
          <v-text-field
            v-model="password"
            :rules="rules"
            type="password"
            @keyup.enter="login"
            label="Password"
          >
          </v-text-field>
          <div class="d-flex flex-row-reverse">
            <v-btn text small color="primary" @click="$router.push('/forgot')">
              Forgot password?
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-btn block class="primary" @click="login" depressed tile>
          Login
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { auth } from "../assets/js/firebase.js";
export default {
  name: "Home",
  components: {},
  data() {
    return {
      isValid: false,
      rules: [v => !!v || "Password is required"],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],

      isAuth: false,
      email: "",
      password: ""
    };
  },
  methods: {
    login() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      vm.$root.loader = true;
      auth
        .signInWithEmailAndPassword(vm.email, vm.password)
        .then(() => {
          vm.$root.loader = false;
          vm.email = "";
          vm.password = "";
        })
        .catch(({ message }) => {
          vm.$root.loader = false;
          vm.$root.alert(message);
        });
    }
  }
};
</script>
<style></style>
